/**
 * Responsive 16:9 YouTube embed.
 *
 * If `isEmbeddable` is false (the uploader disabled embedding), we render
 * the thumbnail with a "Watch on YouTube" overlay link instead of the iframe.
 */

export default function YouTubeEmbed({
  youtubeId,
  title,
  isEmbeddable = true,
  thumbnailUrl,
  autoplay = false,
}) {
  const watchUrl = `https://www.youtube.com/watch?v=${youtubeId}`;

  if (!isEmbeddable) {
    return (
      <div className="tt-embed tt-embed--blocked">
        {thumbnailUrl && <img src={thumbnailUrl} alt={title || ''} />}
        <a
          className="tt-embed__overlay"
          href={watchUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="tt-embed__overlay-play" aria-hidden="true">▶</span>
          <span className="tt-embed__overlay-text">Watch on YouTube</span>
          <small className="tt-embed__overlay-note">
            Embedding disabled by uploader
          </small>
        </a>
      </div>
    );
  }

  const src =
    `https://www.youtube-nocookie.com/embed/${youtubeId}` +
    `?rel=0&modestbranding=1${autoplay ? '&autoplay=1' : ''}`;

  return (
    <div className="tt-embed">
      <iframe
        src={src}
        title={title || 'YouTube video'}
        loading="lazy"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  );
}
